module.exports = __webpack_public_path__ + "static/media/i4.b6f3a1fc.png";